module.exports = __webpack_public_path__ + "static/media/lahore-center.555cc357.svg";